import React, { useMemo, useState } from "react";
import CountryDataCard from "./CountryDataCard";
import EditCountryEmailModal from "./EditCountryEmailModal";
import { emptyStateIcon } from "../../../assets/Icons/icons";
import { GET_COUNTRY } from "../../../api/url";
import { useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { Loader, PageHeader } from "../../../components/ui";
import { strings } from "../../../strings/strings";

const CountryData = () => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const { data: countryData, isLoading, refetch } = useAppQuery({
    queryKey: QUERY_KEYS.COUNTRIES,
    url: GET_COUNTRY,
    method: "GET",
  });


  const countryList = useMemo(() => {
    const rawList = countryData?.results || countryData?.data || [];
    return rawList.map((item, index) => ({
      id: item.id,
      countryName: item.name,
      name: item.name,
      countryCode: item.countryCode,
      isOnline: item.isOnline,
      status: item.status,
      languages: item.supportedLanguages || [],
      supportedLanguages: item.supportedLanguages || [],
      language_count: item.language_count || 0,
      country_email: item.country_email || "",
    }));
  }, [countryData]);

  const handleEditEmail = (country) => {
    setSelectedCountry(country);
    setEditModalOpen(true);
  };

  const handleEditSuccess = () => {
    refetch();
  };

  return (
    <div>
      <PageHeader title={strings.countrydatamanagement} description={strings.displaycountryname} />

      {isLoading ? (
        <div className="flex justify-center items-center py-12">
          <Loader />
        </div>
      ) : countryList.length === 0 ? (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <img src={emptyStateIcon} alt="" className="w-8 h-8 opacity-50" />
          </div>
          <p className="text-lg font-medium text-gray-700 mb-2">{strings.nocountryfound}</p>
          <p className="text-sm text-gray-500">{strings.nocountrydataavailable}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {countryList.map((country) => (
            <CountryDataCard 
              key={country.id || country.countryCode} 
              country={country} 
              onEditEmail={handleEditEmail}
            />
          ))}
        </div>
      )}

      <EditCountryEmailModal
        isOpen={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        country={selectedCountry}
        onSuccess={handleEditSuccess}
      />
    </div>
  );
};

export default CountryData;
